import { createEventDate } from "@anggunpraya-templates/base/app/utils/create-event-date";
import { defineTemplateConfig } from "@anggunpraya-templates/base/app/utils/define-template-config";
import { defineClientConfig } from "@anggunpraya-templates/base/config/define-client-config";

const weddingDate = createEventDate({
  date: "2026-08-25",
  time: "09:00",
  timezone: "WIB",
});

const seoTheme = {
  colorScheme: "light",
  themeColor: "#fbf9ef",
} as const;

export const clientConfig = defineClientConfig({
  eventCode: "AP-20260819-6460",

  template: defineTemplateConfig({
    general: {
      // Nama lengkap pengantin pria
      groom_name: "Firman Rahmad Nuryadi",
      // Nama panggilan pengantin pria
      groom_nickname: "Firman",

      // Nama lengkap pengantin wanita
      bride_name: "Tita Arum Prisilia",
      // Nama panggilan pengantin wanita
      bride_nickname: "Prisilia",

      date: weddingDate.iso,
      time: weddingDate.time,
      subdomain: "firman-prisilia",
      initials: {
        groom: "F",
        bride: "P",
      },
      parents: {
        groom: {
          father: "Maidi",
          mother: "Rini",
          order: "Kedua",
        },
        bride: {
          father: "Wismanto Hadi",
          mother: "Kamilah",
          order: "Kedua",
        },
      },
    },

    others: {
      seo_theme: seoTheme,
      music: {
        enabled: true,
        src: "https://template.anggunpraya.id/audio/krasnoshchok-wedding-romantic-love-music/krasnoshchok-wedding-romantic-love-music-409293.mp3",
      },
    },

    hero: {
      key: "hero",
      enabled: true,
      quotes: {
        text: "Dan segala sesuatu Kami ciptakan berpasang-pasangan agar kamu mengingat (kebesaran Allah)",
        source: "QS. Adz-Dzariyat: 49",
      },
    },

    events: {
      key: "events",
      enabled: true,
    },

    location: {
      key: "location",
      enabled: true,
      items: [
        {
          activity: "Akad Nikah",
          venue: "Kantor Urusan Agama Kecamatan Pasar Kemis",
          address: "Jl. Raya Ps. Kemis No.72, Ps. Kemis, Kec. Ps. Kemis, Kabupaten Tangerang, Banten 15560",
          maps_link: "https://maps.app.goo.gl/5iAbr87qNU1uSshV8?g_st=ic",
          start_time: "09:00",
          end_time: "12:00",
        },
        {
          activity: "Resepsi Pernikahan",
          venue: "Double Sky, Lantai 3 (Double Spoon)",
          address: "Jln. Pluit Permai No. 22 RR/RW 01/04, RT.1/RW.4, Pluit, Kecamatan Penjaringan, Jakarta, Daerah Khusus Ibukota Jakarta 14450",
          maps_link: "https://maps.app.goo.gl/Us9iFC7ce9PebyXUA?g_st=ic",
          start_time: "13:00",
          end_time: "16:00",
        },
      ],
    },

    gallery: {
      key: "gallery",
      enabled: true,
      imageCount: 7,
    },

    rsvp: {
      key: "rsvp",
      enabled: false,
    },

    dress_code: {
      enabled: true,
      key: "dress_code",
      style: "Casual Formal",
      color: "Soft Pink & Cream",
    },

    gift: {
      key: "gift",
      enabled: true,
      bank_accounts: [
        {
          bank_name: "BCA",
          account_name: "Tita Arum Prisilia",
          account_number: "04******13",
          icon: "/bank-first.svg",
        },
        {
          bank_name: "BCA",
          account_name: "Firman Rahmad Nuryadi",
          account_number: "26******57",
          icon: "/bank-first.svg",
        },
      ],
    },

    wishes: {
      key: "wishes",
      enabled: true,
    },
  }),
});
